import { BrowserRouter, Routes, Route, Navigate, NavLink, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import Login     from "./components/Auth/Login";
import Capture   from "./components/Capture/Capture";
import Dashboard from "./components/Dashboard/Dashboard";
import History   from "./components/History/History";
import "./App.css";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" replace />;
}

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="app-layout">
      <nav className="navbar">
        <div className="navbar-brand">
          <span className="navbar-wordmark">Novonesis</span>
        </div>
        <div className="navbar-sep" />
        <span className="navbar-subtitle">Granulometria</span>

        <div className="navbar-links">
          <NavLink to="/nova-analise" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            Nova análise
          </NavLink>
          <NavLink to="/history" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            Histórico
          </NavLink>
        </div>

        <div className="navbar-user">
          <span className="user-name">{user?.name}</span>
          <button className="btn-logout" onClick={() => { logout(); navigate("/login"); }}>
            Sair
          </button>
        </div>
      </nav>
      <main className="app-main">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout><Navigate to="/nova-analise" replace /></Layout></PrivateRoute>} />
          <Route path="/nova-analise" element={<PrivateRoute><Layout><Capture /></Layout></PrivateRoute>} />
          <Route path="/analysis/:id" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
          <Route path="/history" element={<PrivateRoute><Layout><History /></Layout></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
